<template>
  <div class="form-person-wrapper">
    <button
      :type="type"
      :class="'button-default button-default-' + type"
      @click="quickAdd(type)"
    >
      <div class="button-default-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
        >
          <g>
            <g>
              <path
                fill="#7b7b8a"
                d="M18.178 4.068v11.686A3.25 3.25 0 0 1 14.932 19H3.246A3.25 3.25 0 0 1 0 15.754V4.068A3.25 3.25 0 0 1 3.246.822h11.686a3.25 3.25 0 0 1 3.246 3.246zm-1.298 0a1.948 1.948 0 0 0-1.948-1.948H3.246a1.948 1.948 0 0 0-1.948 1.948v11.686c0 1.076.872 1.948 1.948 1.948h11.686a1.948 1.948 0 0 0 1.948-1.948zm-3.896 5.843a.65.65 0 0 1-.649.65H9.738v2.596a.65.65 0 0 1-1.298 0V10.56H5.843a.65.65 0 1 1 0-1.298H8.44V6.665a.65.65 0 0 1 1.298 0v2.597h2.597c.359 0 .65.29.65.649z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="button-default-text">{{ button_text }}</div></button
    ><!-- end button default -->
    <div class="add-person-results">
      <!-- **** PRIKAZ UNESENIH REZULTATA STRANKE **** -->
      <div
        :class="
          'results-selected-wrapper add-person-selected-wrapper add-person-selected-' +
          type
        "
        v-if="type == 'Stranka'"
      >
        <div
          v-for="(rs, key) in add_stranka"
          :key="key"
          class="result-selected"
        >
          <div class="remove-result" @click="removeSelectedResult(key, type)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <g>
                <g>
                  <path
                    fill="#eae9ee"
                    d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                  />
                </g>
                <g>
                  <path
                    fill="#191e2c"
                    d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <!-- ako je odabrana fizička osoba -->
          <div
            :class="'result-name fizicka qrsn' + key + type"
            v-if="add_stranka[key].name"
          >
            <span class="result-name-span">{{ add_stranka[key].name }} </span
            ><span class="result-name-surname">{{
              add_stranka[key].surname
            }}</span>
            <!-- status -->
            <div class="result-status" v-if="add_stranka[key].status_ID == '0'">
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_stranka[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
          <!-- ako je odabrana pravna osoba -->
          <div
            :class="'result-name pravna qrsn' + key + type"
            v-if="add_stranka[key].legal_name"
          >
            <span class="result-name-span">{{
              add_stranka[key].legal_name
            }}</span>
            <!-- status -->
            <div class="result-status" v-if="add_stranka[key].status_ID == '0'">
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_stranka[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
        </div>
      </div>
      <!-- **** END PRIKAZ UNESENIH REZULTATA STRANKE **** -->
      <div
        :class="
          'results-selected-wrapper add-person-selected-wrapper add-person-selected-' +
          type
        "
        v-if="type == 'Drugi_sudionici'"
      >
        <div
          v-for="(rs, key) in add_drugi_sudionici"
          :key="key"
          class="result-selected"
        >
          <div class="remove-result" @click="removeSelectedResult(key, type)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <g>
                <g>
                  <path
                    fill="#eae9ee"
                    d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                  />
                </g>
                <g>
                  <path
                    fill="#191e2c"
                    d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <!-- ako je odabrana fizička osoba -->
          <div
            :class="'result-name fizicka qrsn' + key + type"
            v-if="add_drugi_sudionici[key].name"
          >
            <span class="result-name-span">{{ add_drugi_sudionici[key].name }} </span
            ><span class="result-name-surname">{{
              add_drugi_sudionici[key].surname
            }}</span>
            <!-- status -->
            <div class="result-status" v-if="add_drugi_sudionici[key].status_ID == '0'">
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_drugi_sudionici[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
          <!-- ako je odabrana pravna osoba -->
          <div
            :class="'result-name pravna qrsn' + key + type"
            v-if="add_drugi_sudionici[key].legal_name"
          >
            <span class="result-name-span">{{
              add_drugi_sudionici[key].legal_name
            }}</span>
            <!-- status -->
            <div class="result-status" v-if="add_drugi_sudionici[key].status_ID == '0'">
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_drugi_sudionici[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
        </div>
      </div>
      <!-- **** PRIKAZ UNESENIH REZULTATA PROTUSTRANKE **** -->
      <div
        :class="
          'results-selected-wrapper add-person-selected-wrapper add-person-selected-' +
          type
        "
        v-if="type == 'Protustranka'"
      >
        <div
          v-for="(rs, key) in add_protustranka"
          :key="key"
          class="result-selected"
        >
          <div class="remove-result" @click="removeSelectedResult(key, type)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <g>
                <g>
                  <path
                    fill="#eae9ee"
                    d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                  />
                </g>
                <g>
                  <path
                    fill="#191e2c"
                    d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <!-- ako je odabrana fizička osoba -->
          <div
            :class="'result-name fizicka qrsn' + key + type"
            v-if="add_protustranka[key].name"
          >
            <span class="result-name-span"
              >{{ add_protustranka[key].name }} </span
            ><span class="result-name-surname">{{
              add_protustranka[key].surname
            }}</span>
            <!-- status -->
            <div
              class="result-status"
              v-if="add_protustranka[key].status_ID == '0'"
            >
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_protustranka[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
          <!-- ako je odabrana pravna osoba -->
          <div
            :class="'result-name pravna qrsn' + key + type"
            v-if="add_protustranka[key].legal_name"
          >
            <span class="result-name-span">{{
              add_protustranka[key].legal_name
            }}</span>
            <!-- status -->
            <div
              class="result-status"
              v-if="add_protustranka[key].status_ID == '0'"
            >
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_protustranka[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
        </div>
      </div>
      <!-- **** END PRIKAZ UNESENIH REZULTATA PROTUSTRANKE **** -->

      <!-- **** PRIKAZ UNESENIH REZULTATA NADLEŽNOG TIJELA **** -->
      <div
        :class="
          'results-selected-wrapper add-person-selected-wrapper add-person-selected-' +
          type
        "
        v-if="type == 'Nadležno_tijelo'"
      >
        <div
          v-for="(rs, key) in add_nadlezno_tijelo"
          :key="key"
          class="result-selected"
        >
          <div class="remove-result" @click="removeSelectedResult(key, type)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <g>
                <g>
                  <path
                    fill="#eae9ee"
                    d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                  />
                </g>
                <g>
                  <path
                    fill="#191e2c"
                    d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div
            :class="'result-name pravna qrsn' + key + type"
            v-if="add_nadlezno_tijelo[key].legal_name"
          >
            <span class="result-name-span">{{
              add_nadlezno_tijelo[key].legal_name
            }}</span>
          </div>
        </div>
      </div>
      <!-- **** END PRIKAZ UNESENIH REZULTATA NADLEŽNOG TIJELA **** -->
      <!-- **** PRIKAZ UNESENIH REZULTATA pravnog tijela **** -->
      <div
        :class="
          'results-selected-wrapper add-person-selected-wrapper add-person-selected-' +
          type
        "
        v-if="type == 'Pravno_tijelo'"
      >
        <div
          v-for="(rs, key) in add_pravno_tijelo"
          :key="key"
          class="result-selected"
        >
          <div class="remove-result" @click="removeSelectedResult(key, type)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <g>
                <g>
                  <path
                    fill="#eae9ee"
                    d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
                  />
                </g>
                <g>
                  <path
                    fill="#191e2c"
                    d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <!-- ako je odabrana fizička osoba -->
          <div
            :class="'result-name fizicka qrsn' + key + type"
            v-if="add_pravno_tijelo[key].name"
          >
            <span class="result-name-span">{{ add_pravno_tijelo[key].name }} </span
            ><span class="result-name-surname">{{
              add_pravno_tijelo[key].surname
            }}</span>
            <!-- status -->
            <div class="result-status" v-if="add_pravno_tijelo[key].status_ID == '0'">
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_pravno_tijelo[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
          <!-- ako je odabrana pravna osoba -->
          <div
            :class="'result-name pravna qrsn' + key + type"
            v-if="add_pravno_tijelo[key].legal_name"
          >
            <span class="result-name-span">{{
              add_pravno_tijelo[key].legal_name
            }}</span>
            <!-- status -->
            <div class="result-status" v-if="add_pravno_tijelo[key].status_ID == '0'">
              <span>Status nije odabran</span>
            </div>
            <div class="result-status" v-else>
              <span v-for="(s, i) in statusi" :key="i">
                <span v-if="add_pravno_tijelo[key].status_ID == s.id">{{
                  s.naziv
                }}</span>
              </span>
            </div>
            <!-- end status -->
          </div>
        </div>
      </div>
      <!-- **** END PRIKAZ UNESENIH REZULTATA pravnog tijela **** -->
    </div>
    <form :id="'form-' + type" :class="'form-person-quick form-person-' + type">
      <div class="close-quick-form" @click="closeQuickForm(type)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <g>
            <g>
              <path
                class="outer"
                fill="#f1f1f1"
                d="M18.774 3.2c4.301 4.3 4.301 11.274 0 15.574-4.3 4.301-11.273 4.301-15.574 0-4.3-4.3-4.3-11.273 0-15.574 4.3-4.3 11.274-4.3 15.574 0z"
              />
            </g>
            <g>
              <path
                class="inner"
                fill="#3326ae"
                d="M12.388 14.263l-1.404-1.41-1.405 1.41a1.321 1.321 0 0 1-1.872 0 1.331 1.331 0 0 1 0-1.879l1.404-1.408-1.404-1.409a1.331 1.331 0 0 1 0-1.878 1.321 1.321 0 0 1 1.872 0l1.405 1.408 1.404-1.408a1.321 1.321 0 0 1 1.872 0c.517.518.517 1.36 0 1.878l-1.404 1.409 1.404 1.408c.517.519.517 1.36 0 1.879a1.321 1.321 0 0 1-1.872 0z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="input-quick-select-parent" v-if="type != 'Nadležno_tijelo' && type != 'Pravno_tijelo'">
        <select
          v-model="is_fiz"
          class="input-quick-select"
          name="odabir-pravne-osobe"
        >
          <option value="true">Fizička osoba</option>
          <option value="false">Pravna osoba</option>
        </select>
      </div>
      <input
        v-model="oib"
        :class="'input-quick input-oib-' + type"
        type="text"
        name="OIB"
        placeholder="OIB"
      />
      <div class="ime_prezime" v-if="this.is_fiz == 'true'">
        <input
          v-model="name"
          class="input-quick"
          type="text"
          name="ime"
          placeholder="Ime*"
          required="required"
        />
        <input
          v-model="surname"
          class="input-quick"
          type="text"
          name="prezime"
          placeholder="Prezime*"
          required="required"
        />
      </div>
      <div class="naziv" v-if="this.is_fiz == 'false'">
        <input
          v-model="legal_name"
          class="input-quick"
          type="text"
          name="ime_firme"
          placeholder="Ime pravne osobe*"
        />
      </div>
      <div class="input-quick-select-parent" v-if="type != 'Nadležno_tijelo'">
        <select v-model="status_ID" class="input-quick-select" name="status">
          <option v-for="(s, i) in statusi" :key="i" :value="s.id">
            {{ s.naziv }}
          </option>
        </select>
      </div>
      <!-- <CustomDropdown :additional_classes="'input-quick-select'" :id="'drop_statusi_'+type" v-model="status_ID" :drop_items="statusi" /> -->
      <div class="quick-add-button" @click="enterPerson(type)">
        {{ button_add_text }}
      </div>
    </form>

    <v-dialog v-model="postojeci_dialog" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{postojeci_dialog_text}}
        </div>
        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div class="universal-vdialog-button vbutton-secondary" @click="postojeci_dialog = false"> Odustani </div>
          <div class="universal-vdialog-button vbutton-primary" @click="emitBack"> Dodaj postojeću </div>
          <div class="universal-vdialog-button vbutton-primary" @click="addQuickPerson(temp_current_person); postojeci_dialog = false;">  Dodaj novu </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- end form person quick -->
  </div>
  <!-- end form person wrapper  -->
</template>
	
<script>
import $ from "jquery";
import gsap from "gsap";
// import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import osobe_pr from "../../apiCallers/promise_handler_db/osobe_pr";
import isntitucije_pr from "../../apiCallers/promise_handler_db/institucije";

export default {
  // components: {
  //   CustomDropdown,
  // },
  props: {
    type: String,
    ostalo:String,
    statusi: {
      type: Array,
      required: false,
      default: () => [],
    },
    postojece_fiz_prav:{
      type: Array,
      required: false,
      default: () => [],
    },
    postojeca_nadlezna:{
      type: Array,
      required: false,
      default: () => [],
    },
    postojeci_sudionici:{
      type: Array,
      required: false,
      default: () => [],
    }
  },
  data() {
    return {
      status_ID: "1",
      clicked: false,
      is_fiz: "true",
      oib: "",
      name: "",
      surname: "",
      legal_name: "",
      button_text: "",
      button_add_text: "",
      add_stranka: [],
      add_protustranka: [],
      add_nadlezno_tijelo: [],
      add_pravno_tijelo:[],
      add_drugi_sudionici:[],
      alert_person:null,
      postojeci_dialog:false,
      postojeci_dialog_text:'',
    };
  },
  methods: {
    emitBack(){
      this.$emit('addToAutocomplete', this.alert_person, this.temp_current_person.status_ID, this.type);
      this.postojeci_dialog = false;
      this.closeQuickForm(this.type);
      this.undoForm(this.type);
      //zatvori kreiraj
    },
    openQuickForm(tip) {
      gsap.to(".form-person-" + tip, 0, { display: "flex" });
      gsap.to(".form-person-" + tip, 0.6, { opacity: 1 });
      gsap.to(".form-autocomplete-add-wrapper .button-default-" + tip, 0.35, {
        backgroundColor: "#0acab1",
      });
      gsap.to(".button-default-" + tip, 0.35, { color: "#ffffff" });
      gsap.to(".button-default-" + tip + " .button-default-icon svg path", 0, {
        fill: "#ffffff",
      });
      gsap.to(".add-person-selected-" + tip, 0, { display: "none" });
      gsap.to(".add-person-selected-" + tip, 0.25, { opacity: 0 });
      this.clicked = true;
    },
    closeQuickForm(tip) {
      gsap.to(".form-person-" + tip, 0.4, { opacity: 0 });
      gsap.to(".form-person-" + tip, 0, { display: "none", delay: 0.4 });
      gsap.to(".form-autocomplete-add-wrapper .button-default-" + tip, 0.35, {
        backgroundColor: "#f4f5f9",
      });
      gsap.to(".button-default-" + tip, 0.35, { color: "#7b7b8a" });
      gsap.to(
        ".button-default-" + tip + " .button-default-icon svg path",
        0.35,
        { fill: "#7b7b8a" }
      );
      gsap.to(".add-person-selected-" + tip, 0, { display: "flex" });
      gsap.to(".add-person-selected-" + tip, 0.25, { opacity: 1 });
      this.clicked = false;
      //resetiraj formu da se unese iz početka
      this.undoForm();
      //da se resetira oznaka krivo popunjenog pošto je prazna
      $(".form-person-quick input").css("border", "1px solid #e3e5ee");
    },
    undoForm() {
      this.is_fiz = "true";
      this.oib = "";
      this.name = "";
      this.surname = "";
      this.legal_name = "";
      if (this.type == "Nadležno_tijelo") {
        this.is_fiz = "false";
      }
    },
    quickAdd(tip) {
      if (this.clicked == false) {
        this.openQuickForm(tip);
      } else {
        this.closeQuickForm(tip);
      }
    },

    enterPerson(type) {
      if ((this.is_fiz == 'true' && (this.name == "" || this.surname == "")) || (this.is_fiz == "false" && this.legal_name == "")) {
        //ako ime ili imefirme nisu upisani pofarbaj ih u crveno i ne puštaj dalje
        // if (type != "Protustranka") {
        //   if (this.oib == "") {
        //     $('input[name="OIB"]').css("border", "1px dashed red");
        //   }
        // }
        if (this.name == "" || this.surname == "") {
          $('input[name="ime"]').css("border", "1px dashed red");
          $('input[name="prezime"]').css("border", "1px dashed red");
        }
        if (this.legal_name == "") {
          $('input[name="ime_firme"]').css("border", "1px dashed red");
        }
      }
      else{ 
          // if((this.oibCheck(this.oib)==false)&&(type != 'Protustranka')) //ako oib nije ispravno napisan i ako polje nije protustranka pošto tamo nije obavezno polje
          // {
          // 	alert('OIB je obavezan i sastoji od 11 znamenaka')
          // 	$('input[name="OIB"]').css('border','1px dashed red')
          // }else{
          //pusti sve do kraja
          var obj_fizicka = {};
          obj_fizicka["is_fiz"] = this.is_fiz;
          obj_fizicka["oib"] = this.oib;
          obj_fizicka["name"] = this.name.trim();
          obj_fizicka["surname"] = this.surname.trim();
          obj_fizicka["status_ID"] = this.status_ID;

          var obj_pravna = {};
          obj_pravna["is_fiz"] = this.is_fiz;
          obj_pravna["oib"] = this.oib;
          obj_pravna["legal_name"] = this.legal_name.trim();
          obj_pravna["status_ID"] = this.status_ID;


          if (this.type != "Nadležno_tijelo" && this.type != "Pravno_tijelo") {
            if (this.is_fiz == "true") {
              this.alert_person = this.postojece_fiz_prav.find((osoba)=>osoba.value.toLowerCase() == (this.name.toLowerCase().trim()+' '+this.surname.toLowerCase().trim()))
              console.log(obj_fizicka)
              //ako osoba s imenom i prezimenom postoji onda zaustavi inače pusti
              if (this.alert_person != undefined) {
                this.temp_current_person = obj_fizicka;
                this.postojeci_dialog_text = 'Fizička osoba '+this.alert_person.value+' već postoji u sustavu, jeste li sigurni da želite kreirati novu osobu pod ovim imenom?'
                this.postojeci_dialog = true;
              }
              else{
                this.addQuickPerson(obj_fizicka);
              }
            } 
            else {
              this.alert_person = this.postojece_fiz_prav.find((osoba)=>osoba.value.toLowerCase() == (this.legal_name.toLowerCase().trim()));
              if (this.alert_person != undefined) {
                this.temp_current_person = obj_pravna;
                this.postojeci_dialog_text ='Pravna osoba '+this.alert_person.value+' već postoji u sustavu, jeste li sigurni da želite kreirati novu osobu pod ovim imenom?';
                this.postojeci_dialog = true;
              }
              else{
                this.addQuickPerson(obj_pravna);
              }
            }
          }
          else{
            if (this.type == 'Nadležno_tijelo') {
              this.alert_person = this.postojeca_nadlezna.find((osoba)=>osoba.value.toLowerCase() == (this.legal_name.toLowerCase().trim()));
              if (this.alert_person != undefined) {
                this.temp_current_person = obj_pravna;
                this.postojeci_dialog_text ='Nadležno tijelo '+this.alert_person.value+' već postoji u sustavu, jeste li sigurni da želite kreirati novo pod ovim imenom?';
                this.postojeci_dialog = true;
              }
              else{
                this.addQuickPerson(obj_pravna);
              }
            } else {
              this.alert_person = this.postojeci_sudionici.find((osoba)=>osoba.value.toLowerCase() == (this.name.toLowerCase().trim()+' '+this.surname.toLowerCase().trim()))
              console.log(obj_fizicka)
              //ako osoba s imenom i prezimenom postoji onda zaustavi inače pusti
              if (this.alert_person != undefined) {
                this.temp_current_person = obj_fizicka;
                this.postojeci_dialog_text = 'Sudionik '+this.alert_person.value+' već postoji u sustavu, jeste li sigurni da želite kreirati novu osobu pod ovim imenom?'
                this.postojeci_dialog = true;
              }
              else{
                this.addQuickPerson(obj_fizicka);
              }
            }
          }
      }
    },
    addQuickPerson(add_object){
      if (this.type == "Stranka") {
        if (this.is_fiz == "true") {
          this.add_stranka.push(add_object);
          if (this.$store.state.ime_predmeta.ime_stranke == "") {
              this.$store.state.ime_predmeta.ime_stranke = this.name  + ' ' + this.surname;            
          }
        }
        else{
          this.add_stranka.push(add_object);
          if (this.$store.state.ime_predmeta.ime_stranke == "") {
            this.$store.state.ime_predmeta.ime_stranke = this.legal_name;            
          }
        }
      }
      if (this.type == "Protustranka") {
        if (this.is_fiz == "true") {
          this.add_protustranka.push(add_object);
          if (this.$store.state.ime_predmeta.ime_protustranke == "") {
            this.$store.state.ime_predmeta.ime_protustranke = this.name + ' ' + this.surname;            
          }
        }
        else{
          this.add_protustranka.push(add_object);
          if (this.$store.state.ime_predmeta.ime_protustranke == "") {
            this.$store.state.ime_predmeta.ime_protustranke = this.legal_name;            
          }
        }
      }
      if (this.type == "Nadležno_tijelo") {
        this.add_nadlezno_tijelo[0] = add_object
        this.$emit('removeExisting');
      }
      if (this.type == "Pravno_tijelo") {
        this.add_pravno_tijelo.push(add_object)
      }
      if (this.type == "Drugi_sudionici") {
        this.add_drugi_sudionici.push(add_object)
      }
      this.closeQuickForm(this.type);
      this.undoForm(this.type);

    },
    removeSelectedResult(key, tip) {
      var removeResultValue = $.trim(
        $(".qrsn" + key + tip + " .result-name-span").text()
      );
      var removeResultValueSurname = $.trim(
        $(".qrsn" + key + tip + " .result-name-surname").text()
      );
      //vrati clicknuti value par natrag u items da bude vidljiv među rezultatima
      // remove clicked value pair from final object;
      //mičemo stranku
      if (tip == "Stranka") {
        var i = 0;
        while (i < this.add_stranka.length) {
          //mičemo ovog koji je kliknuti
          var x = removeResultValue;
          if (
            (this.add_stranka[i].name == x && this.add_stranka[i].surname == removeResultValueSurname) ||
            this.add_stranka[i].legal_name == x
          ) {
            if (this.add_stranka[i].name + ' '+ this.add_stranka[i].surname == this.$store.state.ime_predmeta.ime_stranke || this.add_stranka[i].legal_name == this.$store.state.ime_predmeta.ime_stranke ) {
              this.$store.state.ime_predmeta.ime_stranke = ""
            }
            // makni rezultat iz add_stranka
            this.add_stranka.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      if (tip == "Drugi_sudionici") {
        var i = 0;
        while (i < this.add_drugi_sudionici.length) {
          //mičemo ovog koji je kliknuti
          var x = removeResultValue;
          if (
            (this.add_drugi_sudionici[i].name == x && this.add_drugi_sudionici[i].surname == removeResultValueSurname) ||
            this.add_drugi_sudionici[i].legal_name == x
          ) {
            // makni rezultat iz add_stranka
            this.add_drugi_sudionici.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      //mičemo protustranku
      if (tip == "Protustranka") {
        var i = 0;
        while (i < this.add_protustranka.length) {
          //mičemo ovog koji je kliknuti
          var x = removeResultValue;
          if (
            (this.add_protustranka[i].name == x && this.add_protustranka[i].surname == removeResultValueSurname) ||
            this.add_protustranka[i].legal_name == x
          ) {
            if (this.add_protustranka[i].name + ' '+ this.add_protustranka[i].surname == this.$store.state.ime_predmeta.ime_protustranke || this.add_protustranka[i].legal_name == this.$store.state.ime_predmeta.ime_protustranke ) {
              this.$store.state.ime_predmeta.ime_protustranke = ""
            }
            // makni rezultat iz add_stranka
            this.add_protustranka.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      //mičemo nadležno tijelo
      if (tip == "Nadležno_tijelo") {
        var i = 0;
        while (i < this.add_nadlezno_tijelo.length) {
          //mičemo ovog koji je kliknuti
          var x = removeResultValue;
          if (
            this.add_nadlezno_tijelo[i].name == x ||
            this.add_nadlezno_tijelo[i].legal_name == x
          ) {
            // makni rezultat iz add_stranka
            this.add_nadlezno_tijelo.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      if (tip == "Pravno_tijelo") {
        var i = 0;
        while (i < this.add_pravno_tijelo.length) {
          //mičemo ovog koji je kliknuti
          var x = removeResultValue;
          if (
            (this.add_pravno_tijelo[i].name == x && this.add_pravno_tijelo[i].surname == removeResultValueSurname) ||
            this.add_pravno_tijelo[i].legal_name == x
          ) {
            // makni rezultat iz add_pravno_tijelo
            this.add_pravno_tijelo.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    },

    oibCheck(oibCode) {
      var checkDigit, num;
      var code = oibCode.toString();
      if (code.length === 13 && code.substr(0, 2).toUpperCase() === "HR") {
        code = code.substr(2, 11);
      } else if (code.length !== 11) {
        return false;
      }
      var numCheck = parseInt(code, 10);
      if (isNaN(numCheck)) {
        return false;
      }
      num = 10;
      for (var i = 0; i < 10; i++) {
        num = num + parseInt(code.substr(i, 1), 10);
        num = num % 10;
        if (num === 0) {
          num = 10;
        }
        num *= 2;
        num = num % 11;
      }
      checkDigit = 11 - num;
      if (checkDigit === 10) {
        checkDigit = 0;
      }
      return parseInt(code.substr(10, 1), 10) === checkDigit;
    },
  },

  mounted() {
    setTimeout(() => {
          console.log(this.postojece_fiz_prav);

    }, 1000);
    if (this.type == "Stranka") {
      this.button_text = "Kreiraj stranku";
      this.button_add_text = "Dodaj stranku";
    }
    if (this.type == "Drugi_sudionici") {
      this.button_text = "Kreiraj osobu";
      this.button_add_text = "Dodaj osobu";
    }
    if (this.type == "Protustranka") {
      this.button_text = "Kreiraj protustranku";
      this.button_add_text = "Dodaj protustranku";
      $(".input-oib-Protustranka").attr("placeholder", "OIB"); //da nema zvjezdice koja označava required
      $(".input-oib-Protustranka").removeAttr("required");
    }
    if (this.type == "Nadležno_tijelo") {
      this.button_text = "Kreiraj nadležno tijelo";
      this.button_add_text = "Dodaj nadležno tijelo";
      this.is_fiz = "false";
    }
    if (this.type == "Pravno_tijelo") {
      this.button_text = "Kreiraj osobu";
      this.button_add_text = "Dodaj osobu";
      this.is_fiz = "true";
    }
    if(this.ostalo){
      this.button_text = "Kreiraj osobu";
      this.button_add_text = "Dodaj osobu";
    }
  },
  destroyed() {},
};
</script>
	
<style>
</style>